export function removeDuplicates(items, getKey = item => item.id) {
    const seen = new Set();
    return items.filter(item => {
        const key = getKey(item);
        if (seen.has(key)) {
            return false;
        }
        seen.add(key);
        return true;
    });
}
